export const generateTimeOptions = () => {
  const options = [];
  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute of [0, 30]) {
      options.push(`${hour.toString().padStart(2, '0')}:${minute === 0 ? '00' : '30'}`);
    }
  }
  return options;
};

export const normalizeTime = (value) => {
  if (!value) {
    return '';
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }
  const [hoursStr, minutesStr] = trimmed.split(':');
  let hours = Number.parseInt(hoursStr, 10);
  let minutes = Number.parseInt(minutesStr || '0', 10);
  if (Number.isNaN(hours)) {
    hours = 0;
  }
  if (Number.isNaN(minutes)) {
    minutes = 0;
  }
  hours = Math.min(Math.max(hours, 0), 23);
  minutes = Math.min(Math.max(minutes, 0), 59);
  const normalizedMinutes = minutes < 15 ? 0 : minutes < 45 ? 30 : 30;
  return `${hours.toString().padStart(2, '0')}:${normalizedMinutes === 0 ? '00' : '30'}`;
};

export const normalizeTimeInput = (value) => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '').slice(0, 4);
  if (!digits) return '';

  if (digits.length <= 2) {
    const hours = digits.padStart(2, '0');
    return `${hours}:00`;
  }

  const hoursPart = digits.slice(0, digits.length === 3 ? 1 : 2);
  const minutesPart = digits.slice(hoursPart.length);

  const hours = hoursPart.padStart(2, '0').slice(0, 2);
  let minutes = minutesPart.padEnd(2, '0').slice(0, 2);

  if (minutes !== '00' && minutes !== '30') {
    minutes = Number(minutes) <= 15 ? '00' : '30';
  }

  return `${hours}:${minutes}`;
};

export const composeDockHoursRange = (from, to) => {
  if (!from && !to) return '';
  if (from && to) return `${from}-${to}`;
  return from || to || '';
};

export const splitDockHoursRange = (range = '') => {
  if (!range) return { from: '', to: '' };
  const [from = '', to = ''] = range.split('-').map((part) => part.trim());
  return { from, to };
};
